import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { homeMedia } from '../../../config/homeMedia';
import ResponsiveMedia from '../../../components/common/ResponsiveMedia';

const CAPS = [
  {
    id: "01",
    title: "Advertising Intelligence",
    copy: "We monitor competitor campaigns, creative patterns, and messaging across Meta, Google, and TikTok to identify meaningful activity in your category.",
    media: homeMedia.capabilityIntelligenceMedia
  },
  {
    id: "02",
    title: "Strategic Interpretation",
    copy: "We separate actionable signals from vanity metrics, explaining what competitor moves mean and identifying high-leverage opportunities for your brand.",
    media: homeMedia.capabilityInterpretationMedia
  },
  {
    id: "03",
    title: "Creative Action",
    copy: "We translate intelligence into campaign direction, sharper brand positioning, high-converting copy, and scalable digital execution.",
    media: homeMedia.capabilityActionMedia
  }
];

export default function Capabilities() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-[100px] bg-[#050506] border-t border-[#242832]">
      <div className="w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          <div className="lg:col-span-6 space-y-8">
            <div>
              <span className="text-[11px] font-bold tracking-[0.2em] text-[#2F6BFF] uppercase mb-4 block">
                Core Capabilities
              </span>
              <h2 className="text-[clamp(32px,3.5vw,48px)] font-semibold text-white leading-[1.1] tracking-[-0.035em]">
                From observation to creative execution.
              </h2>
            </div>

            <div className="space-y-4">
              {CAPS.map((cap, i) => (
                <button
                  key={cap.id}
                  onClick={() => setActive(i)}
                  onMouseEnter={() => setActive(i)}
                  className={`w-full text-left p-6 md:p-8 rounded-2xl border transition-all duration-300 ${
                    active === i 
                      ? 'bg-[#0B0C0F] border-[#2F6BFF]/50 shadow-xl' 
                      : 'bg-transparent border-transparent opacity-50 hover:opacity-80'
                  }`}
                >
                  <div className="flex items-center gap-5 mb-2">
                    <span className="text-[#2F6BFF] font-bold text-xs tracking-widest">{cap.id}</span>
                    <h3 className="text-xl md:text-2xl font-serif font-bold text-white">{cap.title}</h3>
                  </div>
                  {active === i && (
                    <motion.p
                      initial={{ opacity: 0, y: 8 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="text-[#A7ADB8] text-sm leading-relaxed pl-8 mt-3 font-normal"
                    >
                      {cap.copy}
                    </motion.p>
                  )}
                </button>
              ))}
            </div>

            <div className="pt-2">
              <Link to="/intelligence" className="inline-block text-[13px] font-bold uppercase tracking-[0.1em] text-[#2F6BFF] hover:text-white transition-colors">
                Explore Our Intelligence Approach →
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-[#242832] bg-[#0B0C0F] shadow-2xl">
              <AnimatePresence mode="wait">
                <motion.div
                  key={active}
                  initial={{ opacity: 0, scale: 0.98 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.98 }}
                  transition={{ duration: 0.4 }}
                  className="w-full h-full"
                >
                  <ResponsiveMedia 
                    src={CAPS[active].media}
                    alt={CAPS[active].title}
                    label="CAPABILITY MEDIA"
                  />
                </motion.div>
              </AnimatePresence>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}